import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './file-download-with-image.component.scss';
var FileDownloadWithImage = /** @class */ (function (_super) {
    tslib_1.__extends(FileDownloadWithImage, _super);
    function FileDownloadWithImage(element) {
        return _super.call(this, element) || this;
    }
    FileDownloadWithImage.prototype.init = function () {
        this.size = 6;
        this.currentPagination = 1;
        if (this.element.closest('.file-download-with-image__main')) {
            this.container = Array.from(this.element.querySelectorAll('.file-download-with-image'));
            this.containerDivs = Array.from(this.element.querySelectorAll('.file-download-with-image__container'));
            this.pagination = this.element.querySelector('.pagination');
            this.buttonPrev = this.element.querySelector('.pagination__nav--prev');
            this.buttonNext = this.element.querySelector('.pagination__nav--next');
            this.buttonPrevAll = this.element.querySelector('.pagination__nav--prev-end');
            this.buttonNextAll = this.element.querySelector('.pagination__nav--next-end');
            this.createPagination();
        }
    };
    FileDownloadWithImage.prototype.bindEvents = function () {
        var _this = this;
        if (this.element.querySelector('.pagination__nav--prev')) {
            this.buttonPrev.addEventListener('click', function (event) {
                if (!_this.buttonPrev.classList.contains('pagination__nav--disabled')) {
                    var pagination = _this.currentPagination - 1;
                    _this.currentPagination = pagination;
                    _this.paginationAction(pagination);
                }
            });
        }
        if (this.element.querySelector('.pagination__nav--prev-end')) {
            this.buttonPrevAll.addEventListener('click', function (event) {
                if (!_this.buttonPrev.classList.contains('pagination__nav--disabled')) {
                    var pagination = 1;
                    _this.currentPagination = pagination;
                    _this.paginationAction(pagination);
                }
            });
        }
        if (this.element.querySelector('.pagination__nav--next')) {
            this.buttonNext.addEventListener('click', function (event) {
                if (!_this.buttonNext.classList.contains('pagination__nav--disabled')) {
                    var pagination = _this.currentPagination + 1;
                    _this.currentPagination = pagination;
                    _this.paginationAction(pagination);
                }
            });
        }
        if (this.element.querySelector('.pagination__nav--next-end')) {
            this.buttonNextAll.addEventListener('click', function (event) {
                if (!_this.buttonNextAll.classList.contains('pagination__nav--disabled')) {
                    var buttons = Array.from(_this.element.querySelectorAll('.pagination__item'));
                    var pagination = buttons.length;
                    _this.currentPagination = pagination;
                    _this.paginationAction(pagination);
                }
            });
        }
    };
    FileDownloadWithImage.prototype.paginate = function (event) {
        if (event) {
            var element = void 0;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            var number = parseInt(element.getAttribute('data-number'));
            this.currentPagination = number;
            this.paginationAction(number);
        }
    };
    FileDownloadWithImage.prototype.paginationAction = function (number) {
        var buttons = Array.from(this.element.querySelectorAll('.pagination__item'));
        if (number === 1) {
            this.buttonPrev.classList.add('pagination__nav--disabled');
            this.buttonPrevAll.classList.add('pagination__nav--disabled');
        }
        else {
            this.buttonPrev.classList.remove('pagination__nav--disabled');
            this.buttonPrevAll.classList.remove('pagination__nav--disabled');
        }
        if (number === buttons.length) {
            this.buttonNext.classList.add('pagination__nav--disabled');
            this.buttonNextAll.classList.add('pagination__nav--disabled');
        }
        else {
            this.buttonNext.classList.remove('pagination__nav--disabled');
            this.buttonNextAll.classList.remove('pagination__nav--disabled');
        }
        var startingPoint = 6 * number - 5;
        var endPoint = 6 * number;
        buttons.map(function (button) {
            var getValue = parseInt(button.getAttribute('data-number'));
            if (getValue === number) {
                button.classList.add('pagination__item--active');
            }
            else {
                button.classList.remove('pagination__item--active');
            }
        });
        var indexContainer = 0;
        this.containerDivs.map(function (item) {
            indexContainer++;
            item.classList.add('d-none');
            if (indexContainer >= startingPoint && indexContainer <= endPoint) {
                item.classList.remove('d-none');
            }
        });
    };
    FileDownloadWithImage.prototype.createPagination = function () {
        var _this = this;
        if (this.pagination) {
            var containerItems = this.pagination.querySelector('.pagination__items');
            containerItems.innerHTML = '';
            var unorderedList = document.createElement('ul');
            unorderedList.classList.add('pagination__items');
            unorderedList.classList.add('clearfix');
            var buttonPaginateFirst = document.createElement('li');
            buttonPaginateFirst.classList.add('pagination__item');
            buttonPaginateFirst.classList.add('pagination__item--active');
            buttonPaginateFirst.setAttribute('data-number', '1');
            buttonPaginateFirst.addEventListener('click', function (event) { return _this.paginate(event); });
            buttonPaginateFirst.innerHTML = '1';
            unorderedList.appendChild(buttonPaginateFirst);
            var count = 0;
            var pagination = 1;
            for (var index = 0; index < this.container.length; index++) {
                count++;
                if (count === 7) {
                    pagination++;
                    var buttonPaginateFirst_1 = document.createElement('li');
                    buttonPaginateFirst_1.classList.add('pagination__item');
                    buttonPaginateFirst_1.innerHTML = pagination.toString();
                    buttonPaginateFirst_1.setAttribute('data-number', pagination.toString());
                    buttonPaginateFirst_1.addEventListener('click', function (event) { return _this.paginate(event); });
                    unorderedList.appendChild(buttonPaginateFirst_1);
                    count = 1;
                }
            }
            containerItems.appendChild(unorderedList);
        }
    };
    return FileDownloadWithImage;
}(Base));
export { FileDownloadWithImage };



//////////////////
// WEBPACK FOOTER
// ./components/file-download-with-image/file-download-with-image.component.ts
// module id = 279
// module chunks = 0